import { lazy } from 'react';

const Profile = lazy(() => import(/* webpackChunkName: "profile" */ './Profile'));

export default Profile;
